import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SortableTable, convertDateToDisplayFormat, convertDateToBackendFormat } from './services-table-helper';

@Injectable({
  providedIn: 'root'
})

export class ReproductionsTableService extends SortableTable<any> {
  private baseUrl = environment.API_URL;

  reproductii = [];
  numarReproductii: number;

  constructor(private http: HttpClient) {
    super();
  }

  sortEvent() {
    const tables = this.sort(this.reproductii, this._state.sortColumn, this._state.sortDirection);
    this._tables$.next(tables);
  }

  getReproductionsAPI(obj) {
    return this.http.post(
      `${this.baseUrl}/reproductii/`,
      obj
    ).pipe(map((response: any) => {
      this.reproductii = response.result;
      this.numarReproductii = response.count;
      this.paginate();
      this.sortEvent();
      this._total$.next(this.numarReproductii);

      return response;
    }));
  }

  getTauriIA(req_params) {
    return this.http.post(
      `${this.baseUrl}/reproductii/tauri-ia/`,
      req_params
    );
  }

  getTauriMN(req_params) {
    return this.http.post(
      `${this.baseUrl}/reproductii/tauri-mn/`,
      req_params
    );
  }

  getVaci(req_params) {
    return this.http.post(
      `${this.baseUrl}/reproductii/vaci/`,
      req_params
    );
  }

  getAnexa3Data(obj) {
    return this.http.post(
      `${this.baseUrl}/reproductii/anexa3/`,
      obj
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  getMonta(req_params) {
    return this.http.post(
      `${this.baseUrl}/reproductii/monta/`,
      req_params
    );
  }

  getAutorizatii(obj) {
    return this.http.post(
      `${this.baseUrl}/reproductii/autorizatii/`,
      obj
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  getAnexa3Pdf(companyId: number, anexa3Id: number) {
    return this.http
    .post(
      `${this.baseUrl}/reproductii/anexa3-pdf/`,
        { companyid: companyId, anexa3id: anexa3Id },
        {
          responseType: 'blob'
        }
      ).pipe((response: any) => {
      return response;
    });
  }

  getOperatorsAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/reproductii/operatori/`,
      req_params
    );
  }

  updateAnexa3(obj: any) {
    return this.http.post(
      `${this.baseUrl}/reproductii/montasave/`,
      {
        ...obj,
        date: obj.date ? convertDateToBackendFormat(obj.date) : null,
        date_end: obj.date_end ? convertDateToBackendFormat(obj.date_end) : null,
      }
    ).pipe(map((response: any) => {
      return response;
    }, errors => {
      return errors;
    }));
  }

  salvareMontaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/reproductii/salvare-monta/`,
      req_params
    );
  }

  deleteReproductie(id: number) {
    return this.http.post(
      `${this.baseUrl}/reproductii/delete/`,
      { id }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  anexa3Delete(id: number) {
    return this.http.post(
      `${this.baseUrl}/reproductii/anexa3-delete/`,
      { id }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  exportXLS(obj) {
    return this.http
    .post(
      `${this.baseUrl}/reproductii/export/`,
      {
        ...obj
      },
      {
        responseType: 'blob'
      }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  verificatAPI(obj) {
    return this.http.post(
      `${this.baseUrl}/documente/verificat/`,
      obj
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  /**
   * Paginate Method
   */
  private paginate(): void {
    this.totalRecords = this.numarReproductii;
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.numarReproductii) {
      this._state.endIndex = this.numarReproductii;
    }
  }
}
